export const BASE_URL = 'localhost'